import { useContext } from "react";
import { AssistanceContext } from "../providers";

const useAssistance = () => {
  const assistanceContext = useContext(AssistanceContext);

  if (!assistanceContext) {
    throw new Error("useAssistance must be used within an AssistanceProvider");
  }
  return assistanceContext;
};

export default useAssistance;
